module.exports = __webpack_public_path__ + "img/mn.ead6c73e.svg";